import React, { useEffect, useState } from "react";
import { Map } from "../../common/components/Map";
import { TicketsTable as FreeTicketsTable } from "./free/TicketsTable";
import { TicketsTable as PassTicketsTable } from "./pass/TicketsTable";
import { Legend } from "../../common/components/Legend";
import { PickerContainer } from "../../common/components/PickerContainer";
import { usePickerContext } from "../hooks/usePickerContext";
import { usePickerCore } from "../hooks/usePickerCore";
import { DatesSelector } from "./DatesSelector";
import { graphicEvents } from "../../lib/graphic/GraphicEvents";
import { SeatsPickerValidator } from "./SeatsPickerValidator";
import "./SeatsPicker.scss";

/**
 * @param props
 * @returns {*}
 * @constructor
 */
export function SeatsPicker({...props}) {

    const {state, dispatch} = usePickerContext()
    const {loading, tickets, typeWidget} = state
    const {onSelectSeat, onUnselectSeat, onSelectPit, getWidget, getMultiWidget} = usePickerCore()
    // console.log(state)
    let currentDate = state.dates.find(date => date.current)
    let currentHoursValue = Object.keys(currentDate.hours).find(value => currentDate.hours[value].current)
    // console.log(currentHoursValue)
    // console.log(Object.keys(currentDate.hours))
    if(currentHoursValue === undefined) {
        currentHoursValue = Object.keys(currentDate.hours)[0]
    }
    const currentHours = currentDate.hours[currentHoursValue];

    const [selectedAssuranceData, setSelectedAssuranceData] = useState(null);

    const onCurrentDateChange = () => {
        switch (typeWidget) {
            case 'PASS': {
                /*const datesFromTickets = tickets.map(ticket => ticket.at)
                const uniqDatesFromTickets = datesFromTickets.reduce((uniq, item) => {
                    return uniq.indexOf(item) !== -1 ? uniq : [...uniq, item]
                }, [])
                const datesMustLoaded = uniqDatesFromTickets.map(at => state.dates.find(date => date.at === at))
                if (datesMustLoaded.filter(date => !date.widget).length > 0) getMultiWidget({dates: datesMustLoaded})*/
                getMultiWidget({dates: state.dates})
                break;
            }
            case 'FREE': {
                getWidget({date: currentDate})
                break;
            }
        }
    }

    const setTicketsGraphics = () => {
        let currentTickets = state.tickets.filter(ticket => ticket.at === currentDate.at && ticket.hour === currentHoursValue)
        currentTickets.forEach(ticket => {
            switch (ticket.type) {
                case "SEAT": {
                    graphicEvents.trigger("SET_SELECTED_SEAT", {
                        seatReference: ticket.id
                    })
                    break
                }
                case "PIT": {
                    graphicEvents.trigger("ADD_TICKET_PIT", {
                        pitId: ticket.id
                    })
                    break
                }
            }
        })
    }

    function onMapInitialized() {
        setTicketsGraphics();
        setTimeout(() => {
            dispatch({type: "SET_LOADING", payload: false})
        }, 1500);
    }

    useEffect(onCurrentDateChange, [currentDate.at, currentHoursValue]);
    useEffect(setTicketsGraphics, [currentDate.at, currentHoursValue]);

    // Fonction de gestion du changement d'assurance
    const handleAssuranceChange = (assuranceData) => {
        setSelectedAssuranceData(assuranceData);
    };

    return !currentHours?.widget ? null : (
        <PickerContainer
            className={"SeatsPicker"}
            rightWidth={600}
            loading={loading}
        >
            <Map
                key={"left"}
                assetsPath={""}
                graphicEntities={currentHours.widget.graphicEntities}
                categories={currentHours.widget.categories}
                bookings={currentHours.widget.bookings}
                onSelectSeat={onSelectSeat}
                onUnselectSeat={onUnselectSeat}
                onSelectPit={onSelectPit}
                onAfterInitialization={onMapInitialized}
            />
            <div className={"PickerContainer-rightWrapper"} key={"right"}>
                <section className={"PickerContainer-section PickerContainer-rightHeader"}>
                    <div>
                        <h3 className={"SeatPicker-label"}>{state.label}</h3>
                        {typeWidget === "FREE" && state.device !== "phone" && (
                            <DatesSelector disabled={!props.showDateSelector}/>
                        )}
                    </div>
                    <div
                        title={"Fermer"}
                        className={"PickerContainer-close"}
                        onClick={e => props.onClose()}
                    />
                </section>
                <div className={"PickerContainer-rightColumnWrapper"}>
                    {state.typeWidget === "FREE" && <FreeTicketsTable
                        assurances={currentHours.widget.assurances}
                        onAssuranceChange={handleAssuranceChange} // Passe la fonction de rappel ici
                    />}
                    {state.typeWidget === "PASS" && <PassTicketsTable />}
                    <SeatsPickerValidator
                        selectedAssurance={selectedAssuranceData}
                    />
                    <Legend
                        categories={currentHours.widget.categories}
                        categoriesPrices={currentHours.widget.categoriesPrices}
                    />
                </div>
            </div>
        </PickerContainer>
    );
}
